// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"L--z","inlineTitle":"M--z","sponsoredAdsWrapper":"N--z","marketplaceRecosWrapper":"O--z","brandShopTheLookWrapper":"P--z"};